var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('img',{staticStyle:{"width":"185px"},attrs:{"src":"/public/img/marca.png"}}),_c('span',{staticStyle:{"font-size":"14px","margin-top":"10px"}},[_vm._v("CTI - Coordenação de Tecnologia da Informação")])])
}]

export { render, staticRenderFns }